export const customGetCookie = function(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const getUtmData = function () {
    let utmData = {};
    const sbjs = require('sourcebuster');

    if (typeof sbjs === 'object') {
        sbjs.init({
            domain: location.hostname,
        });

        utmData = {
            'utm_source': sbjs.get.current.src,
            'utm_medium': sbjs.get.current.mdm,
            'utm_term': sbjs.get.current.trm,
            'utm_campaign': sbjs.get.current.cmp,
            'utm_content': sbjs.get.current.cnt,
        };
    }

    return utmData;
}

export const intensaLogger = function (point, level , message, context) {
    let logData = {
        point,
        level,
        message,
        context
    };

    fetch('https://mindbox.ru/journal/logger/entry.php', {
        method: 'POST',
        body: JSON.stringify(logData),
        headers: {'Content-Type': 'application/json'}
    });
}

export const getCurrentEntrancePoint = function () {
    let currentEntrancePoint = '';
    const sbjs = require('sourcebuster');

    if (typeof sbjs === 'object') {
        sbjs.init({
            domain: location.hostname,
        });

        currentEntrancePoint = sbjs.get.current_add.ep;
    }

    return currentEntrancePoint;
}

export const convertUtmToOneLine = function (utmObj) {
    let sortMap = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
    ];
    let arUtmStringValue = [
        'type=UTM'
    ];

    sortMap.map(function (element) {
        arUtmStringValue.push(element + '=' + utmObj[element]);
    });

    return arUtmStringValue.join('&');
}

export function setCookie(name, value, options = {}) {
    options = {
        path: '/',
        // при необходимости добавьте другие значения по умолчанию
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();

    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}

export function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function mindboxAnonimEdit() {

    if (typeof mindbox != "undefined") {
        const uuid = customGetCookie('mindboxDeviceUUID')
            ? customGetCookie('mindboxDeviceUUID')
            : customGetCookie('deviceUUID');
        let clientId = getGoogleClientId();
        let yaClientId = getYandexClientId();

        if (clientId.length > 0) {

            let data =   {
                deviceuuid: uuid,
                firstclientid: clientId,
                firstmetrikaid: yaClientId
            };

            fetch('https://mindbox.ru/journal/wp-admin/admin-ajax.php?action=mindbox-anonim-edit', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {'Content-Type': 'application/json'}
            });

            setCookie('_delay_mindbox_request', '', {'max-age': -1});

        } else {
            setCookie('_delay_mindbox_request', 'Y', {'max-age': 3600*24, path: '/'});
        }
    } else {
        console.error('anonim edit error: mindbox is undefined');
        console.warn('anonim edit error: mindbox is undefined');
    }
}

export function checkInitGoogleAnalytics() {

    if (window.initGaCounter === undefined) {
        window.initGaCounter = 1;
    }

    let gaCookie = customGetCookie('_ga');

    if (
        gaCookie !== undefined
        || typeof ga === 'function'
        || window.initGaCounter > 6
    ) {
        mindboxAnonimRegist();
    } else {
        window.initGaCounter += 1;
        setTimeout(() => {checkInitGoogleAnalytics()}, 500);
    }
}

export function mindboxAnonimRegist() {

    if (typeof mindbox != "undefined") {
        mindbox("sync", {
            operation: "checkvisitor",
            data: {},
            onSuccess: function (response) {
                const uuid = customGetCookie('mindboxDeviceUUID') ? customGetCookie('mindboxDeviceUUID') : customGetCookie('deviceUUID');

                if (typeof response.customer == "undefined" && typeof uuid != "undefined") {
                    let customFields = {};
                    let utmData = getUtmData();

                    if (Object.keys(utmData).length > 0) {
                        customFields = {
                            firstutmsource: utmData['utm_source'],
                            firstutmmedium: utmData['utm_medium'],
                            firstutmterm: utmData['utm_term'],
                            firstutmcampaign: utmData['utm_campaign'],
                            firstutmcontent: utmData['utm_content'],
                            firstattribution: convertUtmToOneLine(utmData)
                        };
                    }

                    customFields.entrancepage = getCurrentEntrancePoint();

                    let  anonimRegistData = {
                        customer: {
                            ids: {
                                deviceuuid: uuid,
                                // firstclientid: this.getGoogleClientId()
                            },
                            customFields: customFields
                        }
                    };

                    if (customGetCookie('_fbc') !== undefined) {
                        anonimRegistData.customer.ids.fbc = customGetCookie('_fbc');
                    }

                    if (customGetCookie('_fbp') !== undefined) {
                        anonimRegistData.customer.ids.fbp = customGetCookie('_fbp');
                    }

                    mindbox("async", {
                        operation: "anonimRegist",
                        data: anonimRegistData,
                        onSuccess:() => {
                            intensaLogger('anonimRegist', 'info', 'data', anonimRegistData);
                            setTimeout(()=>{
                                mindboxAnonimEdit();
                            }, 600);

                        },
                        onError: function (error) {
                            intensaLogger('anonimRegist', 'error', 'data', anonimRegistData);
                        }
                    });
                } else if (typeof uuid != "undefined") {
                    /* вызов операции fbcookieregist*/
                    let fbcookieregistData = {
                        customer: {
                            ids: {
                                deviceuuid: uuid,
                            },
                        }
                    };

                    let mustBeSend = false;

                    if (typeof response.customer.ids.fbp === 'undefined'
                        && customGetCookie('_fbp') !== undefined) {
                        fbcookieregistData.customer.ids.fbp = customGetCookie('_fbp');
                        mustBeSend = true;
                    }

                    if (typeof response.customer.ids.fbc === 'undefined'
                        && customGetCookie('_fbc') !== undefined) {
                        fbcookieregistData.customer.ids.fbc = customGetCookie('_fbc');
                        mustBeSend = true;
                    }

                    if (mustBeSend) {
                        mindbox('async', {
                            operation: 'fbcookieregist',
                            data: fbcookieregistData,
                        });
                    }
                }
            },
            onValidationError: function (messages) {
            },
            onError: function (error) {
            }
        });
    }
}

export function mindboxAnonimEditSetEntrancePage() {
    const cookieName = 'mindboxAnonimEditSetEntrancePage';

    if (getCookie(cookieName) === undefined ) {
        if (typeof mindbox != "undefined") {
            const uuid = customGetCookie('mindboxDeviceUUID') ? customGetCookie('mindboxDeviceUUID') : customGetCookie('deviceUUID');

            if (!uuid) {
                return false;
            }

            let data = {
                deviceuuid: uuid,
                customFields: {
                    entrancepage: getCurrentEntrancePoint()
                }
            };

            fetch('https://mindbox.ru/journal/wp-admin/admin-ajax.php?action=mindbox-anonim-edit-ep', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {'Content-Type': 'application/json'}
            });

            setCookie(cookieName, true, {path: '/'});
        }
    }
}

export function getYandexClientId() {
    return customGetCookie('_ym_uid')
}

export function getGoogleClientId() {
    let ga = customGetCookie('_ga');
    let clientId = '';

    if (ga !== undefined) {
        let temp = ga.split('.');
        clientId = temp[2] + '.' + temp[3];
    }

    return clientId;
}






